import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// import createPersistedState from 'vuex-persistedstate';
// import * as Cookies from 'js-cookie';

//Separate Module States
import AuthStore from './modules/auth/store';
import commentsModule from './modules/comments/store';
import cartStore from './modules/cart/store';
import headerSearch from './modules/header-search/store';
import addToWishlistStore from './modules/add-to-wishlist/store';
import catalogStore from './modules/catalog/store';
import globalSearch from './modules/global-search/store';
import notificationsStore from './modules/notifications/store';
import ProductVariantStore from './modules/product-variants/store';
import PriceRangeStore from './modules/price-range/store';
import EstimatorStore from './modules/estimator/store';

export default new Vuex.Store({
  state: {
    AuthStore: !!localStorage.getItem('AuthStore'),
  },

  plugins: [
    // createPersistedState({
    // 	paths: [ 'AuthStore' ]
    // storage: {
    // 	getItem: key => Cookies.get(key),
    // 	setItem: (key, value) => Cookies.set(key, value, { expires: 3 }),
    // 	removeItem: key => Cookies.remove(key)
    // }
    // })
  ],

  modules: {
    AuthStore,
    commentsModule,
    cartStore,
    headerSearch,
    addToWishlistStore,
    catalogStore,
    globalSearch,
    notificationsStore,
    ProductVariantStore,
    PriceRangeStore,
    EstimatorStore,
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/store.js